import { RuntimeConfig } from "@/types/types.ts";
import { DeliveryServicesOptions } from "@/components/DeliveryServices/DeliveryServicesOptions.tsx";
import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema.ts";
import { Services } from "@/types/serviceTypes.ts";
import { SharedServicesActions } from "@/utils/services/useSharedServices.ts";

type Props = {
  /**
   * Indicates if a product variant is available to order.
   */
  availableToOrder: boolean;
  /**
   * Feature flag enabling the delivery service questionnaire for complex installs
   */
  deliveryServiceQuestionnaireEnabled: boolean;
  /**
   * Feature flag enabling for testing use of free promo tag on free services
   */
  showFreeServicePromoTag: boolean;
  /**
   * Feature flag enabling service questionnaire drawer (vs modal)
   */
  enableServiceQuestionnaireDrawer: boolean;
  hasWholePoundsOnlyEnabled?: boolean;
  /**
   * A string representing the raw experiences
   */
  experiencesRawObject: Experiences;
  /**
   * Runtime configuration object
   */
  runtimeConfig: RuntimeConfig;
  /** Available services — passed down from the container. */
  availableServices: Services;
  /** Store mutation actions — passed down from the container. */
  actions: SharedServicesActions;
};

export const DeliveryServicesUI = ({
  availableToOrder,
  deliveryServiceQuestionnaireEnabled,
  showFreeServicePromoTag,
  enableServiceQuestionnaireDrawer,
  hasWholePoundsOnlyEnabled,
  runtimeConfig,
  experiencesRawObject,
  availableServices,
  actions,
}: Props) => {
  const serviceQuestionnaireScript = `/service-questionnaire/${enableServiceQuestionnaireDrawer ? "drawer" : "index"}.html`;
  return (
    <div
      data-testid="product:services-and-warranties"
      data-component="DeliveryServices"
    >
      <DeliveryServicesOptions
        availableToOrder={availableToOrder}
        deliveryServiceQuestionnaireEnabled={
          deliveryServiceQuestionnaireEnabled
        }
        showFreeServicePromoTag={showFreeServicePromoTag}
        hasWholePoundsOnlyEnabled={hasWholePoundsOnlyEnabled}
        experiencesRawObject={experiencesRawObject}
        runtimeConfig={runtimeConfig}
        availableServices={availableServices}
        actions={actions}
      />
      {deliveryServiceQuestionnaireEnabled && (
        <ESIInclude
          src={serviceQuestionnaireScript}
          id={"service-questionnaire"}
        />
      )}
    </div>
  );
};
